var map = {
	"./auth-background.webp": 1923,
	"./close-btn.webp": 1924,
	"./icon-caution.webp": 1925,
	"./icon-checked.webp": 1926,
	"./icon-contact-us.webp": 1927,
	"./icon-email.webp": 1928,
	"./icon-eye-close.webp": 1929,
	"./icon-eye-open.webp": 1930,
	"./icon-forget-phone.webp": 1931,
	"./icon-forget-whatsapp.webp": 1932,
	"./icon-google.webp": 1933,
	"./icon-login-email-2.webp": 1934,
	"./icon-login-email.webp": 1935,
	"./icon-password.webp": 1936,
	"./icon-robot-select.webp": 1937,
	"./icon-robot-unselect.webp": 1938,
	"./icon-telegram.webp": 1939,
	"./icon-user.webp": 1940,
	"./jackpot-cn.webp": 1941,
	"./jackpot-mobile-cn.webp": 1942,
	"./jackpot-mobile-ms.webp": 1943,
	"./jackpot-mobile.webp": 1944,
	"./jackpot-ms.webp": 1945,
	"./jackpot.webp": 1946,
	"./login-bg.webp": 1947
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;